import { render, staticRenderFns } from "./KpiSalesTopTable.vue?vue&type=template&id=6738ff14&"
import script from "./KpiSalesTopTable.vue?vue&type=script&lang=js&"
export * from "./KpiSalesTopTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports